// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"5976c740","703":"8a281902","787":"4d52eb6f"}[chunkId] + ".chunk.js";
};